<template>
    <svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1080 1080" style="enable-background: new 0 0 1080 1080" xml:space="preserve">
        <path
            :fill="color"
            d="M542.7,717.7l-203-200.8l85.6-85.6l116.8,116.8l256.9-256.9c-137.4-143.1-364.8-147.7-507.9-10.3
	s-147.7,364.8-10.3,507.9s364.8,147.7,507.9,10.3C898.5,693.8,930,530.9,867.5,392.4L542.7,717.7z"
        />
    </svg>
</template>

<script>
export default {
    name: "Check",
    props: ["color"],
};
</script>
